import { getSubdomain } from "../components/shared/StylesheetInjector"

export const loadKlaviyo = () => {
  var subdomain = getSubdomain()

  var klaviyoKey
  switch (subdomain) {
    case "fleetadvise":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_FLEETADVISE_KEY
      break
    case "ntw":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_NTW_KEY
      break
    case "zubie":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_ZUBIE_KEY
      break
    case "fleetamerica":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_PUBLIC_KEY
      break
    case "fuelman":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_FUELMAN_KEY
      break
    case "fleetcor":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_FLEETCOR_KEY
      break
    case "discounttire":
      klaviyoKey = process.env.REACT_APP_KLAVIYO_DISCOUNTTIRE_KEY
      break
  }

  if (!klaviyoKey) {
    console.error("Klaviyo public key is missing.")
    return
  }

  const script = document.createElement("script")
  script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoKey}`
  script.async = true
  script.onload = () => {
    console.log("Klaviyo script loaded successfully.")
  }
  document.body.appendChild(script)
}
export const logOutKlaviyo = () => {
  document.cookie = `_kuid_=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`
}
